import React from "react";
import SubstanceUniverse from "./SubstanceUniverse";

export default class SubstanceInfoBasic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTruncated: true, // Initial state is truncated
      showAllClasses: false, // Add this line
    };
  }

// Function to transform aliases as per the rules
transformAliases(aliases) {
  return aliases.map(alias => {
    // List of aliases to exclude from fully uppercase transformation
    const excludedAliases = ["bud", "pot", "cid", "ket", "jet"];
    // Check if the alias is one of the excluded ones
    if (excludedAliases.includes(alias.toLowerCase())) {
      return alias.charAt(0).toUpperCase() + alias.slice(1).toLowerCase();
    }

    const isComplex = alias.includes(',') || alias.includes('-');
    const formattedAlias = isComplex ? alias : 
      alias.length <= 3 ? alias.toUpperCase() : 
      alias.charAt(0).toUpperCase() + alias.slice(1).toLowerCase();
    return formattedAlias;
  });
}


  // Function to split and style each word in the categories
  styleCategories(classes) {
    if (!classes) return [];
  
    const words = [];
  
    if (classes && Object.keys(classes).length > 0) {
      Object.entries(classes).forEach(([category, classList]) => {
        if (Array.isArray(classList) && classList.length > 0) {
          classList.forEach((className, index) => {
            words.push(
              <span key={`${category}-${index}`} style={{
                border: '1px solid black',
                borderRadius: '5px',
                padding: '5px 10px',
                marginRight: '10px',
                marginBottom: '10px',
                display: 'inline-block',
                fontSize: '0.9em',
              }}>
                {className}
              </span>
            );
          });
        }
      });
    }
  
    words.push(
      <span 
        key="toggle-classes" 
        style={{
          border: '1px solid black',
          borderRadius: '5px',
          padding: '5px 10px',
          marginRight: '10px',
          marginBottom: '10px',
          display: 'inline-block',
          fontSize: '0.9em',
          cursor: 'pointer',
          color: this.state.showAllClasses ? '#000' : 'rgb(102, 102, 102)',
          backgroundColor: this.state.showAllClasses ? '#e0e0e0' : '#ffffff',

        }}
        onClick={() => this.setState(prevState => ({ showAllClasses: !prevState.showAllClasses }))}
      >
        {this.state.showAllClasses ? 'Close chart' : 'Show all classes'}
      </span>
    );
  
    return words;
  }

// Function to format and join effects or categorized effects as comma-separated, lowercase strings
// Additionally, capitalize the first letter after every period but keep the rest lowercase.
formatEffects = (effectsList) => {
  if (!effectsList || effectsList.length === 0) return "";

  return effectsList
    .map(effect => {
      // Convert the entire string to lowercase
      effect = effect.toLowerCase();
      // Capitalize the first letter after each period followed by a space
      return effect.replace(/(?:\.\s*)([a-z])/g, (match, p1) => match.replace(p1, p1.toUpperCase()));
    })
    .join(", ");
};

  // Function to truncate text based on character count
  truncateEffects = (text, maxChars) => {
    return text.length > maxChars ? text.substring(0, maxChars) + '...' : text;
  };

  // Function to render the uncategorized effects content with truncation
  renderEffects = (effectsText) => {
    const maxChars = 100; // Maximum characters before truncation
    const truncatedText = this.truncateEffects(effectsText, maxChars);
    const isTextTruncated = effectsText.length > maxChars;

    // Ensure that uncategorized effects are truncated by default
    if (this.state.isTruncated === undefined) {
      this.setState({ isTruncated: true });
    }

    return (
      <div style={{ marginBottom: '10px', marginTop: '10px' }}>
        <strong>Uncategorized effects: </strong>
        <span
          style={{ whiteSpace: 'pre-line', cursor: 'pointer' }}
          onClick={() => this.setState(prevState => ({ isTruncated: !prevState.isTruncated }))}
        >
          {this.state.isTruncated ? truncatedText : effectsText}
          {isTextTruncated && this.state.isTruncated && (
            <span style={{ marginLeft: '5px' }}>(click to show all)</span>
          )}
          {isTextTruncated && !this.state.isTruncated && (
            <span style={{ textDecoration: 'underline', fontSize: '1em', marginLeft: '5px' }}>
              Click to show less.
            </span>
          )}
        </span>
      </div>
    );
  };

  // Function to handle rendering categorized effects with truncation
  renderCategorizedEffects = (category, effectsList) => {
    // Skip empty categories
    if (!effectsList || effectsList.length === 0) return null;

    const effectsText = this.formatEffects(effectsList);
    const maxChars = 100; // Maximum characters before truncation
    const truncatedText = this.truncateEffects(effectsText, maxChars);
    const isTextTruncated = effectsText.length > maxChars;

    // Ensure that each category is truncated by default
    if (this.state[`isTruncated_${category}`] === undefined) {
      this.setState({ [`isTruncated_${category}`]: true });
    }

    return (
      <div key={category} style={{ marginBottom: '20px', marginTop: '10px' }}>
        <strong>{category}: </strong>
        <span
          style={{ whiteSpace: 'pre-line', cursor: 'pointer', marginTop: '10px' }}
          onClick={() =>
            this.setState(prevState => ({
              [`isTruncated_${category}`]: !prevState[`isTruncated_${category}`],
            }))
          }
        >
          {this.state[`isTruncated_${category}`] ? truncatedText : effectsText}
          {isTextTruncated && this.state[`isTruncated_${category}`] && (
            <span style={{ marginLeft: '5px' }}>(click to show all)</span>
          )}
          {isTextTruncated && !this.state[`isTruncated_${category}`] && (
            <span style={{ textDecoration: 'underline', fontSize: '1em', marginLeft: '5px' }}>
              Click to show less.
            </span>
          )}
        </span>
      </div>
    );
  };

// Function to render the effects content with truncation
renderEffectsCard() {
  const { info } = this.props;

  const categorizedEffects = info.categorized_effects || {};

  // Now fetch the "Uncategorized effects" from categorized_effects
  const uncategorizedEffectsText = categorizedEffects['Uncategorized effects'] ? 
    this.formatEffects(categorizedEffects['Uncategorized effects']) : ""; // Format the uncategorized effects

  const allowedCategories = ["Physical effects", "Mental effects", "Sensory effects", "Uncategorized effects"];

  return (
    <div style={{ marginTop: '10px' }}>
      {/* Display uncategorized effects from categorized_effects
      {uncategorizedEffectsText && this.renderEffects(uncategorizedEffectsText)} */}

      {/* Display specific categorized effects */}
      {Object.keys(categorizedEffects).length > 0 && (
        <div>
          {Object.entries(categorizedEffects)
            .filter(([category]) => allowedCategories.includes(category)) // Filter to show only allowed categories
            .map(([category, effectsList]) =>
              this.renderCategorizedEffects(category, effectsList)
            )}
        </div>
      )}
    </div>
  );
}

  render() {
    const { info, substance } = this.props; // Odbieramy substance z props
    const { name, commonName } = substance;

    if (!info) {
      return null;
    }

    const aliasesExist = info.aliases != null;
    const classesExist = info.classes != null;

    return (
      <table>
        <tbody>
          <tr>
            <td><h2 style={{marginTop: "-10px"}}>{commonName}</h2></td>
          </tr>

          {aliasesExist && (
            <tr>
              <td style={{ paddingBottom: '0px' }}>
                {this.transformAliases(info.aliases).map((alias, index) => (
                  <span key={index} style={{
                    marginRight: '10px',
                    fontWeight: '450',
                    fontSize: '0.8em',
                    display: 'inline-block'
                  }}>{alias}</span>
                ))}
              </td>
            </tr>
          )}

          {classesExist && (
            <tr>
              <td style={{ paddingTop: '10px' }}>
                {this.styleCategories(info.classes)}
              </td>
            </tr>
          )}

          {this.state.showAllClasses && (
            <tr>
              <td>
                {/* Przekazujemy substance do SubstanceUniverse */}
                <SubstanceUniverse substance={substance} />
              </td>
            </tr>
          )}

<tr>
  <td style={{ paddingBottom: '10px', paddingTop: '10px' }}>
    {info.summary ? info.summary : "This is an obscure substance with no summary in PsychoanutWiki or TripSit. Reliable data is unavailable."}
  </td>
</tr>


          {info.effects && (
            <tr>
              <td>
                {this.renderEffectsCard()}
              </td>
            </tr>
          )}

        </tbody>
      </table>
    );
  }
}

export const classes = {
  // twoje dane klas
};
